import MainLogoWhite from './MainLogoWhite';
export default MainLogoWhite;